/* Etiquetas multiidoma en castellano. */
export default {
  "loginView.error": "Credenciales incorrectas",
  "loginView.password": "Contraseña",
  "loginView.submit": "Entrar",
  "loginView.title": "Acceso",
  "loginView.username": "Usuario",
};
